exports.components = {
  "component---src-templates-default-jsx": () => import("./../../../src/templates/Default.jsx" /* webpackChunkName: "component---src-templates-default-jsx" */),
  "component---src-templates-dynamic-zip-packages-jsx": () => import("./../../../src/templates/DynamicZipPackages.jsx" /* webpackChunkName: "component---src-templates-dynamic-zip-packages-jsx" */),
  "component---src-templates-paid-social-video-jsx": () => import("./../../../src/templates/PaidSocialVideo.jsx" /* webpackChunkName: "component---src-templates-paid-social-video-jsx" */)
}

